var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasPhoto)?_c('DrawablePhotoV1OrV2',{attrs:{"image":_vm.item.params,"drawing":_vm.drawing,"title":_vm.$t('Annotate image'),"remove-button-title":_vm.$t('Remove annotation'),"can-be-deleted":false},on:{"change":_vm.valueChanged}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }